<template>
  <b-card style="height: 600px">
    <b-card-title> 运维 </b-card-title>

    <!-- 工单统计 -->
    <b-row>
      <b-col class="text-center cursor-pointer" cols="3" @click="showDetails('agent')">
        <b-avatar rounded variant="light-primary">
          <b-icon-zoom-in />
        </b-avatar>
        <label>诊断</label>
        <h4 class="my-0 font-digit">
          {{ projectOperation.agent.length }}
        </h4>
      </b-col>

      <b-col class="text-center cursor-pointer" cols="3" @click="showDetails('alarm')">
        <b-avatar rounded variant="light-danger">
          <b-icon-bell-fill />
        </b-avatar>
        <label>报警</label>
        <h4 class="my-0 font-digit">
          {{ projectOperation.alarm.length }}
        </h4>
      </b-col>

      <b-col class="text-center cursor-pointer" cols="3" @click="showDetails('inspection')">
        <b-avatar rounded variant="light-success">
          <b-icon-check2-square />
        </b-avatar>
        <label>巡检</label>
        <h4 class="my-0 font-digit">
          {{ projectOperation.inspection.length }}
        </h4>
      </b-col>

      <b-col class="text-center cursor-pointer" cols="3" @click="showDetails('repair')">
        <b-avatar rounded variant="light-warning">
          <b-icon-wrench />
        </b-avatar>
        <label>报修</label>
        <h4 class="my-0 font-digit">
          {{ projectOperation.repair.length }}
        </h4>
      </b-col>
    </b-row>

    <hr class="mt-1 mb-0 offsetMargin" />
    <b-tabs>
      <b-tab title="夏季">
        <vue-perfect-scrollbar style="height: 370px">
          <b-table :fields="tableColumns" :items="strategySummer" class="w-100 h-100" small striped>
            <template #cell(param_name)="data">
              <div>
                {{ data.item.param_name }}
              </div>
            </template>
            <template #cell(change)="data">
              <feather-icon
                v-if="data.item.cur_value !== data.item.rec_value"
                :class="data.item.cur_value > data.item.rec_value ? 'text-danger' : 'text-success'"
                :icon="data.item.cur_value > data.item.rec_value ? 'ArrowDownIcon' : 'ArrowUpIcon'"
              />
              <feather-icon v-else class="text-primary" icon="MinusIcon" />
            </template>
          </b-table>
        </vue-perfect-scrollbar>
      </b-tab>

      <b-tab title="冬季">
        <vue-perfect-scrollbar style="height: 370px">
          <b-table :fields="tableColumns" :items="strategyWinter" class="w-100 h-100" small striped>
            <template #cell(param_name)="data">
              {{ data.item.param_name }}
            </template>
            <template #cell(change)="data">
              <feather-icon
                v-if="data.item.cur_value !== data.item.rec_value"
                :class="data.item.cur_value > data.item.rec_value ? 'text-danger' : 'text-success'"
                :icon="data.item.cur_value > data.item.rec_value ? 'ArrowDownIcon' : 'ArrowUpIcon'"
              />
              <feather-icon v-else class="text-primary" icon="MinusIcon" />
            </template>
          </b-table>
        </vue-perfect-scrollbar>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue';
import { computed, onMounted, reactive, toRefs, watch } from '@vue/composition-api';
import { momentFmt } from '@/libs/utils/moment';
import { scroll_active, scroll_stop } from '@/libs/utils/autoScroll';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { getParams } from '@/api/diagnosis';
import { routerParams } from '@/libs/utils/routerParams';

export default {
  name: 'Operation',
  props: {
    project_operation: [Object],
  },
  setup(props) {
    const event = reactive({
      projectOperation: computed(() => {
        return props.project_operation;
      }),
      selected: 'agent',
      tableColumns: [
        {
          label: '节能运行参数',
          key: 'param_name',
          thStyle: { width: '65%' },
          tdStyle: { width: '65%' },
        },
        {
          label: '当前值',
          key: 'cur_value',
          thStyle: { width: '20%' },
          tdStyle: { width: '20%' },
        },
        {
          label: '推荐值',
          key: 'rec_value',
          thStyle: { width: '20%' },
          tdStyle: { width: '20%' },
        },
      ],
      strategySummer: [
        // {
        //   param_name: '冷冻水供水温度 (℃)',
        //   cur_value: '7.2',
        //   rec_value: '8',
        //   change: '',
        // },
        // {
        //   param_name: '制冷机开启台数',
        //   cur_value: '1',
        //   rec_value: '1',
        //   change: '',
        // },
        // {
        //   param_name: '冷冻水泵频率 (Hz)',
        //   cur_value: '45',
        //   rec_value: '42',
        //   change: '',
        // },
        // {
        //   param_name: '冷却水泵频率 (Hz)',
        //   cur_value: '47',
        //   rec_value: '42',
        //   change: '',
        // },
        // {
        //   param_name: '冷却塔开启台数',
        //   cur_value: '1',
        //   rec_value: '1',
        //   change: '',
        // },
        // {
        //   param_name: '冷却塔风机频率 (Hz)',
        //   cur_value: '35',
        //   rec_value: '30',
        //   change: '',
        // },
        // {
        //   param_name: '开机时间',
        //   cur_value: '8:00',
        //   rec_value: '8:30',
        //   change: '',
        // },
        // {
        //   param_name: '关机时间',
        //   cur_value: '18:00',
        //   rec_value: '17:30',
        //   change: '',
        // },
      ],
      strategyWinter: [
        // {
        //   param_name: '冷凝侧出水温度 (℃)',
        //   cur_value: '45',
        //   rec_value: '42',
        //   change: '',
        // },
        // {
        //   param_name: '冷凝侧回水温度 (℃)',
        //   cur_value: '40',
        //   rec_value: '38',
        //   change: '',
        // },
        // {
        //   param_name: '蒸发侧出水温度 (℃)',
        //   cur_value: '10',
        //   rec_value: '9',
        //   change: '',
        // },
        // {
        //   param_name: '蒸发侧回水温度 (℃)',
        //   cur_value: '12',
        //   rec_value: '13',
        //   change: '',
        // },
        // {
        //   param_name: '冷却水泵频率 (Hz)',
        //   cur_value: '45',
        //   rec_value: '43.5',
        //   change: '',
        // },
        // {
        //   param_name: '室内侧水泵频率 (Hz)',
        //   cur_value: '50',
        //   rec_value: '48',
        //   change: '',
        // },
        // {
        //   param_name: '冷机开启台数',
        //   cur_value: '2',
        //   rec_value: '2',
        //   change: '',
        // },
        // {
        //   param_name: '开机时间',
        //   cur_value: '8:00',
        //   rec_value: '7:50',
        //   change: '',
        // },
        // {
        //   param_name: '关机时间',
        //   cur_value: '18:00',
        //   rec_value: '17:30',
        //   change: '',
        // },
      ],
    });
    const showDetails = (type) => {
      event.selected = type;
    };
    watch(
      () => event.projectOperation,
      () => {
        for (let key in event.projectOperation) {
          if (event.projectOperation[key].length > 0) {
            event.selected = key;
            break;
          }
        }
      }
    );
    const fetchGetParams = () => {
      const params = {
        project_id: routerParams('project_id'),
      };
			getParams(params).then((res) => {
        if (res.data) {
          event.strategySummer = res.data.strategySummer;
          event.strategyWinter = res.data.strategyWinter;
        }
      });
    };
    onMounted(() => {
      fetchGetParams();

      scroll_active('#project-detail-operation-scroll-notice');
    });
    return {
      ...toRefs(event),
      showDetails,
      momentFmt,
      scroll_active,
      scroll_stop,
			fetchGetParams
    };
  },
  components: {
    AppTimeline,
    AppTimelineItem,
    VuePerfectScrollbar,
  },
};
</script>

<style lang="scss">
.timeline-item {
  padding-left: 1.5rem !important;

  div > h6 {
    font-size: 0.9rem !important;
  }
}

.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.table {
  font-size: 12px;
}
</style>
